import React from 'react';

import { CostsContent } from 'components/Pages/Admin/Itinerary/Landing/Costs';
import { TMainCostInfoProps } from 'components/Pages/Admin/Itinerary/Landing/Costs/types';

import useCosts from './functions';

export default function Costs() {
  const {
    type,
    guestCount,
    value,
    currency,
    costsCurrency,
    roomingConfigurationEnabled,
    roomingConfigurationWysiwyg,
    accommodationType,
    notesEnabled,
    notesWysiwyg,
    includesWysiwyg,
    notIncludesWysiwyg,
    handleClick,
    determined,
    topTextEnabled,
  } = useCosts();
  const mainCostsInfoProps = {
    type,
    guestCount,
    value,
    currency,
    costsCurrency,
    roomingConfigurationEnabled,
    roomingConfigurationWysiwyg,
    accommodationType,
    determined,
    topTextEnabled,
  } as TMainCostInfoProps;

  return (
    <CostsContent
      mainCostsInfoProps={mainCostsInfoProps}
      handleClick={handleClick}
      notesEnabled={notesEnabled}
      notesWysiwyg={notesWysiwyg}
      includesWysiwyg={includesWysiwyg}
      notIncludesWysiwyg={notIncludesWysiwyg}
    />
  );
}
